export const LABELS = {
  ALL_STUDENTS_RESPONSES: 'View All Student Responses',
  STUDENT_RESPONSES: 'View Student Responses',
  YOUR_RESPONSES: 'View Your Responses',
};
